export const CONTRACT_LIST_VIEW = {
    ACTIVE: 'active',
    EXPIRING: 'expiring',
    DRAFT: 'draft',
    EXPIRED: 'expired',
    ARCHIVED: 'archived',
    ALL: 'all',
};
//# sourceMappingURL=contracts.js.map